import * as React from 'react';
import { ModulesBasic, IPropsBasic, ModulesRoot } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import AppSdk from 'kts-platform-frame/appSdk';
// import UIComponents from './UI.Components';
import ModulesRoute, { } from './Modules.Route';
import { history } from 'kts-platform-frame/routes';
// import MyIcon from 'src/display/components/Icon';
import {
    Tabs,
    Icon
} from 'antd';
import {
    PageHeaderTop,
} from 'kts-xui';
import './index.less';
// const css = require('./index.scss');
// const TabPane = Tabs.TabPane;

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据 */
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class CompanyInfo extends ModulesBasic<IProps, ModulesState> {

    public state: ModulesState = new ModulesState();

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentWillMount() {
        ModulesAction.getCompanyInfo(ModulesAction.setupDefaultLocation);
    }

    componentDidMount() {
        this.discremPath();
    }

    render() {
        const appInfo = AppSdk.instance && AppSdk.instance.user && AppSdk.instance.user['appInfo'];
        const userInfo = AppSdk.instance && AppSdk.instance.user && AppSdk.instance.user.userInfo;
        return (
            <ModulesRoot action={ModulesAction}>
                <div className="special">
                    <PageHeaderTop
                        activeKey={this.state.activeKey}
                        title="公司管理"
                        help="公司管理"
                        onChange={this.tabsOnChange}
                        // tabBarExtraContent={<div style={{ display: 'flex' }}><a onClick={this.gocompanyPublic}>访问公开首页</a></div>}
                        tabs={[
                            {
                                tab: <div>
                                    <Icon type="gongsi1" />
                                    <span>公司信息</span>
                                </div>, tabKey: '/workbench/platform/companyinfo'
                            },
                            {
                                tab: <div>
                                    <Icon type="idcard" />
                                    <span>公司资质</span>
                                </div>, tabKey: '/workbench/platform/companyinfo/qualification'
                            },
                            // {
                            //     tab: <div>
                            //         <Icon type="safety-certificate" />
                            //         <span>代理商授权</span>
                            //     </div>, tabKey: '/workbench/platform/companyinfo/agentAgree'
                            // },
                            // {
                            //     tab: <div>
                            //         <Icon type="safety-certificate" />
                            //         <span>DID管理</span>
                            //     </div>, tabKey: '/workbench/platform/companyinfo/did'
                            // },
                        ]}

                    >
                    </PageHeaderTop>
                </div>
                {ModulesRoute.getChildReact()}
                {/* <Tabs
                    activeKey={this.state.activeKey}
                    onChange={this.tabsOnChange}
                    className={css.modules}
                    tabBarExtraContent={<div style={{ display: 'flex' }}><a onClick={this.gocompanyPublic}>访问公开首页</a></div>}
                >
                    <TabPane
                        key="/workbench/platform/companyinfo"
                        tab={(
                            <div>
                                <Icon type="gongsi1" />
                                <span>公司信息</span>
                            </div>
                        )}
                    >
                        {ModulesRoute.getChildReact()}
                    </TabPane>
                    <TabPane
                        key="/workbench/platform/companyinfo/qualification"
                        tab={(
                            <div>
                                <Icon type="idcard" />
                                <span>公司资质</span>
                            </div>
                        )}
                    >
                        {ModulesRoute.getChildReact()}
                    </TabPane>
                    <TabPane
                        key="/workbench/platform/companyinfo/agentAgree"
                        tab={(
                            <div>
                                <Icon type="safety-certificate" />
                                <span>代理商授权</span>
                            </div>
                        )}
                    >
                        {ModulesRoute.getChildReact()}
                    </TabPane>
                    <TabPane
                        key="/workbench/platform/companyinfo/did"
                        tab={(
                            <div>
                                <Icon type="safety-certificate" />
                                <span>DID管理</span>
                            </div>
                        )}
                    >
                        {ModulesRoute.getChildReact()}
                    </TabPane>
                </Tabs> */}
            </ModulesRoot>
        );
    }
    // 访问公开首页
    private gocompanyPublic = () => {
        let url = window.parent.location.origin + '/companyPublic/' + this.state.companyInfo.companyId;
        window.open(url, '_blank');

    }
    private discremPath = () => {
        const pathname = history.location.pathname;
        ModulesAction.changeUpdateKey(pathname);
    }

    private tabsOnChange = (key) => {
        // console.log(key,key === '/workbench/platform/companyinfo/qualification', 'sss');
        if (key === '/workbench/platform/companyinfo') {
            ModulesAction.changeUpdateKey('/workbench/platform/companyinfo');
            history.push('/workbench/platform/companyinfo');
        } else if (key === '/workbench/platform/companyinfo/qualification') {
            ModulesAction.changeUpdateKey('/workbench/platform/companyinfo/qualification');
            history.push('/workbench/platform/companyinfo/qualification');
        } else if (key === '/workbench/platform/companyinfo/agentAgree') {
            ModulesAction.changeUpdateKey('/workbench/platform/companyinfo/agentAgree');
            history.push('/workbench/platform/companyinfo/agentAgree');
        } else if (key === '/workbench/platform/companyinfo/did') {
            ModulesAction.changeUpdateKey('/workbench/platform/companyinfo/did');
            history.push('/workbench/platform/companyinfo/did');
        }
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/CompanyInfo/index.tsx